/**
 * Лестница до срока. Проигрыш обязан быть концом длинной лестницы,
 * а не случайностью: игрок, потерявший сорок игровых дней из-за одного
 * броска, не начинает заново — он закрывает вкладку навсегда.
 *
 * Ступени: облава → подписка → следствие → суд → срок.
 * На каждой есть выход за деньги, за репутацию или за время.
 */

export type JusticeStage = 'clean' | 'podpiska' | 'sledstvie' | 'sud';

/** Сколько дней облавы помнят: реже — и счётчик обнуляется. */
export const RAID_MEMORY_DAYS = 10;
/** Со второй облавы — подписка, с третьей — следствие. */
export const PODPISKA_RAIDS = 2;
export const SLEDSTVIE_RAIDS = 3;
/** Сколько дней от следствия до суда. */
export const DAYS_TO_COURT = 5;

export interface Investigation {
  /** Сколько облав накопилось за память. */
  raids: number;
  /** День последней облавы. */
  lastRaidDay: number;
  /** День суда, если следствие уже назначило дату. */
  courtDay: number | null;
}

export const CLEAN_RECORD: Investigation = { raids: 0, lastRaidDay: 0, courtDay: null };

/** Ступень по накопленным облавам. */
export function stageOf(investigation: Investigation, day: number): JusticeStage {
  const forgotten = day - investigation.lastRaidDay > RAID_MEMORY_DAYS;
  const raids = forgotten ? 0 : investigation.raids;

  if (investigation.courtDay !== null && day >= investigation.courtDay) return 'sud';
  if (raids >= SLEDSTVIE_RAIDS) return 'sledstvie';
  if (raids >= PODPISKA_RAIDS) return 'podpiska';
  return 'clean';
}

/** Новая облава: счётчик растёт, а после третьей назначается суд. */
export function afterRaid(investigation: Investigation, day: number): Investigation {
  const forgotten = day - investigation.lastRaidDay > RAID_MEMORY_DAYS;
  const raids = (forgotten ? 0 : investigation.raids) + 1;
  const courtDay =
    raids >= SLEDSTVIE_RAIDS && investigation.courtDay === null ? day + DAYS_TO_COURT : investigation.courtDay;
  return { raids, lastRaidDay: day, courtDay };
}

/** Под подпиской палево за ночь не спадает: сидишь и ждёшь. */
export function nightHeatRelief(stage: JusticeStage, base: number): number {
  return stage === 'clean' ? base : Math.round(base * 0.25);
}

/**
 * Во сколько встанет решить вопрос до суда. Чем ближе суд и чем больше
 * облав, тем дороже; репутация со смотрящим сбивает цену.
 */
export function bribeOutPrice(investigation: Investigation, smotryashiyRep: number): number {
  const base = 400_000 + investigation.raids * 250_000;
  const discount = Math.min(0.5, Math.max(0, smotryashiyRep) / 200);
  return Math.round(base * (1 - discount));
}

export type RunOutcome = 'active' | 'srok' | 'mogila';

/** Что делает проигрыш в этом режиме: закрывает прохождение или откатывает день. */
export function lossIsFinal(mode: 'mamkin' | 'pacanski'): boolean {
  return mode === 'pacanski';
}
